import { render, staticRenderFns } from "./CreateCompany.vue?vue&type=template&id=677f0f29&scoped=true&"
import script from "./CreateCompany.vue?vue&type=script&lang=js&"
export * from "./CreateCompany.vue?vue&type=script&lang=js&"
import style0 from "./CreateCompany.vue?vue&type=style&index=0&id=677f0f29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f0f29",
  null
  
)

export default component.exports